module.exports = __webpack_public_path__ + "static/media/large-mounjaro-green.7b3cd668.png";